'use client';

import React from 'react';
import { BellOff } from 'lucide-react';

/**
 * "Reminders off" badge for the envelope list.
 *
 * WHY THIS IS IN THE LIST AND NOT JUST THE DETAIL PANEL:
 * silencing reminders on an outstanding consent means a patient quietly stops being
 * chased and the form may never get signed. That is the actual risk of the feature -
 * not anything technical. Making the state visible everywhere an envelope appears is
 * what makes it self-correcting; hidden, it is a trap.
 *
 * TRI-STATE, and the distinction matters:
 *   false -> reminders are OFF   -> show the badge
 *   true  -> reminders are ON    -> show nothing (the normal case)
 *   null/undefined -> UNKNOWN    -> show nothing
 *
 * Null means DocuSpa has never observed this envelope's notification settings. It must
 * never be rendered as "on", because that would assert something we have not checked.
 * The value is a cache of DocuSign-side state, refreshed whenever the envelope's
 * settings are read or changed, so it can go stale if someone edits it in the DocuSign
 * console directly.
 */
const RemindersBadge = ({ remindersEnabled, className = '' }) => {
  if (remindersEnabled !== false) return null;

  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium bg-slate-100 text-slate-700 rounded ${className}`}
      title="Automatic reminder emails are turned off for this envelope. It is still open and can still be signed."
    >
      <BellOff className="w-3 h-3" />
      Reminders off
    </span>
  );
};

export default RemindersBadge;
